
<template>
  <div class="LoginRegisterView">
    <section class="welcome">
      <div class="welcome__container-wrapper">
        <div class="welcome__container">
          <h2 class="welcome__title">
            Witaj w aplikacji
            <span class="welcome__title--orange">call web!</span>
          </h2>
          <p
            class="welcome__paragraph"
          >
            Najłatwiejszy w obsłudze system do zarządzania kontaktem z użytkownikami Twojej strony internetowej.
          </p>
        </div>

        <div class="welcome__icons-container">
          <div class="welcome__icon-box">
            <img src="@/assets/images/loginRegisterImages/icon1.png"
                 alt
                 class="welcome__icon"
            >
            <p class="welcome__icon-text">
              Ocena połączenia
            </p>
          </div>
          <div class="welcome__icon-box">
            <img src="@/assets/images/loginRegisterImages/icon2.png"
                 alt
                 class="welcome__icon"
            >
            <p class="welcome__icon-text">
              Harmonogram
            </p>
          </div>
          <div class="welcome__icon-box">
            <img src="@/assets/images/loginRegisterImages/icon3.png"
                 alt
                 class="welcome__icon"
            >
            <p class="welcome__icon-text">
              Call tracking
            </p>
          </div>
          <div class="welcome__icon-box">
            <img src="@/assets/images/loginRegisterImages/icon4.png"
                 alt
                 class="welcome__icon"
            >
            <p class="welcome__icon-text">
              Nagrywanie rozmów
            </p>
          </div>
          <div class="welcome__icon-box">
            <img src="@/assets/images/loginRegisterImages/icon5.png"
                 alt
                 class="welcome__icon"
            >
            <p class="welcome__icon-text">
              Powiadomienia
            </p>
          </div>
          <div class="welcome__icon-box">
            <img src="@/assets/images/loginRegisterImages/icon6.png"
                 alt
            >
            <p class="welcome__icon-text">
              Wirtualne działy
            </p>
          </div>
        </div>
        <p class="welcome__paragraph">
          Tylko jeden krok dzieli Cię od podwyższenia jakości obsługi klienta i zwiększenia sprzedaży w Twojej firmie.
        </p>
        <div class="welcome__without-wrapper">
          <span class="welcome__without-text">bez ograniczeń</span>
          <span class="welcome__without-text">bez zobowiązań</span>
          <span class="welcome__without-text">bez umowy</span>
        </div>
        <p class="welcome__bottom-text">
          Nie wymagamy podpięcia karty kredytowej
        </p>
      </div>
    </section>
    <section class="login-register">
      <img :src="require('@/assets/images/loginRegisterImages/logo.png')"
           class="login-register__logo"
      >
      <div v-loading="$store.getters['authorization/isWaitingForAuthorisation']">
        <div class="login-register__button-wrapper">
          <button
            class="login-register__button login-register__button--login"
            large
            @click="handleLogin"
          >
            Zaloguj się
          </button>
        </div>
        <div class="login-register__button-wrapper">
          <button
            class="login-register__button login-register__button--register"
            large
            @click="handleRegister"
          >
            Zarejestruj się
          </button>
        </div>
      </div>
      <p class="contact-info">
        kontakt@callweb.pl
      </p>
    </section>
  </div>
</template>

<script>

export default {
  name: 'LoginRegister',
  methods: {
    handleLogin() {
      const gateway = '78a35bcb-3063-41e8-be99-c6f69fb1c0d7';
      this.$auth.loginToPlatform({ gateway, lang: 'pl' });
    },
    handleRegister() {
      const gateway = '78a35bcb-3063-41e8-be99-c6f69fb1c0d7';
      this.$auth.registerToPlatform({ gateway, lang: 'pl' });
    },
  },
};
</script>

<style lang="sass">
.LoginRegisterView
  display: flex
  width: 100%
  min-height: 100vh
  height: 100%
  background: white
  box-sizing: border-box

  @include breakpoint(small)
    padding: 20px

  // welcome section (left)

  .welcome
    background-color: #23252C
    width: 50%
    box-sizing: border-box
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center

    @include breakpoint(small)
      display: none

    &__container-wrapper
      display: inline-block
      flex-direction: column
      justify-content: center
      align-items: center

    &__container
      display: inline-block

    &__title
      color: white
      font-size: 36px
      font-weight: bold
      text-align: center
      font-family: 'Montserrat', sans-serif
      text-align: left

      &--orange
        color: #F6A821
        font-family: inherit

    &__paragraph
      color: white
      font-size: 16px
      text-align: center
      font-family: 'Montserrat', sans-serif
      text-align: left
      width: 0;
      min-width: 100%

    &__icons-container
      display: grid
      text-align: center
      grid-template-columns: repeat(3, 1fr)
      grid-gap: 20px
      margin: 60px 0

    &__icon-box
      display: flex
      justify-content: center
      align-items: center
      flex-direction: column

    &__icon
      height: 50px
      margin-bottom: 10px

    &__icon-text
      text-transform: uppercase
      font-size: 10px
      font-weight: 500
      font-family: 'Montserrat', sans-serif

    &__without-wrapper
      display: flex
      justify-content: space-between

    &__without-text
      text-transform: uppercase
      margin: 68px 0 40px 0
      font-size: 16px

    &__bottom-text
      position: relative
      margin: 0 auto
      text-align: center
      font-size: 16px
      width: fit-content
      &::before, &::after
        position: absolute
        content: ''
        display: block
        width: 54px
        height: 1px
        background-color: #66738F
        top: 50%
      &::before
        left: -64px
      &::after
        right: -64px

  // login-register section (right)

  .login-register
    width: 50%
    display: flex
    flex-direction: column
    align-items: center
    margin-top: 300px

    @include breakpoint(small)
      width: 100%
      margin-top: 20vh

      @media (orientation: landscape)
        margin-top: 10vh

    &__logo
      width: 100%
      max-width: 334px
      margin-bottom: 160px

      @include breakpoint(small)
        margin-bottom: 20vh

        @media (orientation: landscape)
          margin-bottom: 10vh

    &__button-wrapper
      display: flex
      flex-direction: column
      justify-content: center
      align-items: center


    &__button
      width: 480px
      margin: 0
      border: none
      margin: 7px 0
      padding: 10px 0
      border-radius: 25px
      font-family: 'Montserrat', sans-serif
      font-size: 16px
      cursor: pointer
      transition: all 0.2s ease-in-out

      @include breakpoint(small)
        width: 90vw
        max-width: 480px

      &--login
        background-color: #F6A821
        color: #fff

        &:hover
          filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.15));

      &--register
        background-color: #fff
        border: 1px solid #66738F
        color: #66738F

        &:hover
          box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);

  .contact-info
    text-align: center
    position: relative
    margin-top: 200px
    color: #66738F

    @include breakpoint(small)
      position: absolute
      bottom: 20px
      margin-top: 10vh

    &::before
      position: absolute
      content: ''
      display: block
      width: 15px
      height: 12px
      background: url('../assets/images/loginRegisterImages/contact_icon.png')
      background-repeat: no-repeat
      background-size: cover
      top: 50%
      left: -24px
      transform: translateY(-50%)

  .el-loading-mask
    width: 100vw
    height: 100vh
    position: fixed
    top: 0
    left: 0
</style>
